module.exports = __webpack_public_path__ + "static/fassade-comeniushof-245fbbaaa66fd69e5dfb340b5e7839cc.png";